import React, { createContext, useContext, useState } from "react";

const TourContext = createContext();

export function TourProvider({ children }) {
  const [steps, setSteps] = useState([]);
  const [stepIndex, setStepIndex] = useState(0);
  const [running, setRunning] = useState(false);
  const [currentTourKey, setCurrentTourKey] = useState(null);


  const startTour = (steps, key) => {
    setSteps(steps);
    setCurrentTourKey(key);
    setStepIndex(0);
    setRunning(true);
  };

  const next = () => {
    setStepIndex((prev) => {
      const nextIndex = prev + 1;
      if (nextIndex >= steps.length) {
        if (currentTourKey) {
          localStorage.setItem(currentTourKey, "completed");
        }
        setRunning(false);
        return 0;
      }
      return nextIndex;
    });
  };

  const skip = () => {
    if (currentTourKey) {
      localStorage.setItem(currentTourKey, "completed");
    }
    setRunning(false);
    setStepIndex(0);
  };

  return (
    <TourContext.Provider
      value={{
        steps,
        stepIndex,
        running,
        startTour,
        next,
        skip
      }}
    >
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  return useContext(TourContext);
}